DJ.addBehavior('js-cuisine-a-la-carte', '.js-cuisine-a-la-carte', {
  attach: function (context, settings, behavior) {
    var holder = jQuery('.js-cuisine-a-la-carte');
    var slider = holder.find('.slider');
    var controls = holder.find('.slider-controls')
    slider.slick({
      adaptiveHeight: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      infinite: false,
      dots: true,
      appendDots: controls.find('.slide-dots'),
      prevArrow: controls.find('.slide-prev'),
      nextArrow: controls.find('.slide-next')
    });
  },

  detach: function (context, settings) { }
});

DJ.addBehavior('js-astuces-culinaires', '.js-astuces-culinaires', {
  attach: function (context, settings, behavior) {
    var holder = jQuery('.js-astuces-culinaires');
    var slider = holder.find('.slider');
    var controls = holder.find('.slider-controls')
    slider.slick({
      adaptiveHeight: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      infinite: false,
      dots: true,
      appendDots: controls.find('.slide-dots'),
      prevArrow: controls.find('.slide-prev'),
      nextArrow: controls.find('.slide-next')
    });
  },

  detach: function (context, settings) { }
});

DJ.addBehavior('js-aliments-more', '.js-aliments-more', {
  attach: function (context, settings, behavior) {
    jQuery('.js-aliments-more').on('click', function (e) {
      jQuery('.section__aliments_item.privilegier[hidden]').slice(0, 10).removeAttr('hidden');
      jQuery('.section__aliments_item.eviter[hidden]').slice(0, 10).removeAttr('hidden');

      var next = jQuery('.section__aliments_item[hidden]');

      if (next.length === 0) {
        jQuery('.js-aliments-more').attr('hidden', '');
      }
    });
  },

  detach: function (context, settings) { }
});
